export enum SnapshotStatus {
  NOT_FOUND = "NOT_FOUND",
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  ERROR = "ERROR",
}

export enum TxStatus {
  PROCESSED = "PROCESSED",
  FAILED = "FAILED",
}

export type Snapshot = {
  wallet: string;
  balance: string;
  type: string;
};

export type SnapshotSubmitForm = {
  tokenAddress: string;
  toBlock: number;
  chainId: number;
};

export interface ILocalStorageSnapshot {
  account: string;
  snapshotId: string;
  timestamp: number;
  chainId: number;
}

declare global {
  interface Window {
    _env_: {
      [key: string]: string;
    };
  }
}
